import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CtaSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-primary-100">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6">
          {t('home.ctaTitle')}
        </h2>
        <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
          {t('home.ctaDescription')}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/contact"
            className="bg-primary-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-primary-700 transition-colors"
          >
            {t('home.ctaContact')}
          </Link>
          <Link
            to="/scholarships"
            className="bg-white text-primary-600 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors"
          >
            {t('home.ctaApply')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;